var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ComConfig", {
    attrs: {
      title: "悬浮窗-1",
      component_name: "7-1-pop-bar-1",
      limit: 1,
      styleConfig: _vm.styleConfig,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }